import { LoadingService } from './../../../core/services/loading.service';
import { TranslatedVariables } from './../../../commons/translated-variables';
import { WorkFlowService } from './../../../core/services/work-flow.service';
import { AuthorizationProperties } from './../../../authentication/auth-info';
import { Customer } from './../../../model/customer';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LoginService } from 'src/app/core/services/login.service';
import { OperationResult } from '@tb/auth';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { ContractDetails } from 'src/app/model/contractDetails';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { CustomerService } from 'src/app/core/services/customer.service';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { CountryService } from 'src/app/core/services/country.service';
import { IndustryProductID } from 'src/app/model/industry';

@Component({
    selector: 'ms-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class UsersListComponent implements OnInit {
    displayedColumns: string[] = [];
    searchUser: string = '';
    dataSourceContractsDetails: MatTableDataSource<ContractDetails>;
    expandedElement: ContractDetails | null;
    public loading: boolean = false;
    authorizationProperties: AuthorizationProperties;
    authorizationStored;
    noItems: boolean = false;
    _userspaginator: MatPaginator;
    public selectedInstanceKey: string = '';
    public isAllowedToChooseMultiInstances: boolean = false;
    countriesAllowedToChooseMWInstances: string[] = [];

    @ViewChild('resellerpaginator') set paginator(contentOrders: MatPaginator) {
        if (contentOrders) {
            // initially setter gets called with undefined
            this._userspaginator = contentOrders;
            const paginatorIntl = this._userspaginator._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceContractsDetails) {
                this.dataSourceContractsDetails.paginator = this._userspaginator;
            }
        }
    }

    // _ordersSort
    @ViewChild(MatSort) instancesSort: MatSort;
    @Output() editPartner = new EventEmitter<Customer>();

    constructor(
        public workFlow: WorkFlowService,
        private variable: TranslatedVariables,
        public loadingService: LoadingService,
        private loginService: LoginService,
        private configurationService: ConfigurationService,
        private workflow: WorkFlowService,
        private dialog: MatDialog,
        public customerService: CustomerService,
        public magoWebService: MagoWebService,
        public storeRoleService: StoreRolesService,
        public countryService: CountryService
    ) {
        this.displayedColumns = ['expand', 'RagioneSocialeCliente', 'CodiceCliente'];
    }

    async ngOnInit() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        //BindData
        this.customerService.companyInfo$.subscribe(async (companyInfo) => {
            await this.BindData();
        });
    }

    private async BindData() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.dataSourceContractsDetails = new MatTableDataSource<ContractDetails>();
        //TODO da inserire il codice titolare del rivenditore che arriva dalla login
        let result: OperationResult = await this.configurationService.getContractsByCodiceTitolare(
            this.authorizationProperties.accountName,
            this.customerService.codiceTitolare
        );

        this.dataSourceContractsDetails.data = result.Content as ContractDetails[];

        this.noItems = this.dataSourceContractsDetails.filteredData.length <= 0;
        this.dataSourceContractsDetails.paginator = this._userspaginator;
        this.dataSourceContractsDetails.sort = this.instancesSort;
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    async SubscriptionActivation(element: ContractDetails) {
        this.loading = true;
        this.loadingService.setLoading(this.loading);

        var countries = require('i18n-iso-countries');
        element.NazioneCliente = countries.alpha3ToAlpha2(element.NazioneCliente);
        let result: OperationResult = await this.configurationService.attivazioneZContratto(
            element,
            this.workflow.getLanguageForCms(),
            this.workflow.getLanguageForCms(),
            this.authorizationProperties.accountName,
            this.selectedInstanceKey
        );
        this.loading = false;
        this.loadingService.setLoading(this.loading);

        if (result.Result) {
            let msg = `${this.variable.subscription_successfully_activated}.<br />${
                this.variable.subcriptionCode
            }:${result.Content.toString()},<br />
          ${this.variable.subscriptionDescription}:${element.RagioneSocialeCliente}`;

            const dlgAsk = this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: this.variable.subscription_successfully_activated,
                    Message: msg,
                },
            });
            dlgAsk.afterClosed().subscribe(async () => {
                this.BindData();
            });
        } else {
            const dlgAsk = this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: this.variable.errorTitle,
                    Message: result.Message,
                },
            });
        }
    }

    // -----------------------------------------------------------------------------
    applyFilterSearch(event: any) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSourceContractsDetails.filter = filterValue.trim().toLowerCase();

        this.noItems = this.dataSourceContractsDetails.filteredData.length <= 0;
    }
    // -----------------------------------------------------------------------------
    clearUserSearch() {
        this.searchUser = '';
        this.dataSourceContractsDetails.filter = this.searchUser.trim().toLowerCase();
        this.noItems = false;
    }

    public async setExpandedElement(element: ContractDetails) {
        if (!element) this.expandedElement = null;
    }
    public setParameters(row: ContractDetails) {
        this.expandedElement = this.expandedElement === row ? null : row;
    }

    public isAllowedToMW_MultiInstances(productID: string) {
        //se è una sub magoweb
        let isMagoWeb: boolean = productID === IndustryProductID.MW;
        let countryExists = this.magoWebService.countriesAllowedToChooseMWInstances.find((x) => x === this.countryService.resellerCountry);
        //se la nazione del rivenditore è tra quelle elencate nel record
        let canChooseInstance =
            this.magoWebService.countriesAllowedToChooseMWInstances &&
            this.magoWebService.countriesAllowedToChooseMWInstances.length > 0 &&
            countryExists &&
            countryExists.length > 0;
        // o un account internal
        let isInternal = this.storeRoleService.IsInternal;
        return isMagoWeb && (canChooseInstance || isInternal);
    }

    selectedInstanceDescri(selectedInstanceDescri: string) {}
    selectedInstanceValue(selectedInstanceValue: string) {
        this.selectedInstanceKey = selectedInstanceValue;
    }
}
